import { useEffect, useState } from 'react';
import { getLiteHeaderState, subscribeLiteHeaderState } from './liteHeaderStore';

const useLiteHeaderState = () => {
  const [data, setData] = useState(() => getLiteHeaderState());

  useEffect(() => {
    const unsubscribe = subscribeLiteHeaderState(setData);
    setData(getLiteHeaderState());
    return unsubscribe;
  }, []);

  return data;
};

export default useLiteHeaderState;
